import React, { useState } from "react";

import db from "../../firebase";
import { doc, getDocs, collection } from "firebase/firestore";


async function getProjects(db) {
    
    const citiesCol = collection(db, 'projects');
    const projectSnapshot = await getDocs(citiesCol);
    const projectList = projectSnapshot.docs.map(doc => doc.data());
    
     console.log(projectList);
     
     projectList.forEach((doc) => {
         console.log(doc);
         console.log(doc['name']);
     });
    
    return projectList;
}



export default function Examples() {
    
    
    console.log(111);
    getProjects(db);
    
     //console.log(getProjects(db));

    /*
    getDocs(userRef).then((snap) => {
        console.log('#');
        console.log(snap);
      snap.forEach((doc) => {
        console.log('1=='+doc.id);
        console.log('2=='+doc.data());
      });
    });
    */
      
      
    //memory = db.collection("memory");
    //const user_ref = doc(db, "memory", "gameStart");
    //console.log(user_ref);
    
    return <>
    
    111
    
    </>
        
        
    
        
}

